<template>
    <div class="error-icon">
        <div class="error-icon__right"></div>
        <div class="error-icon__left"></div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="scss">
    // The icon specifics
    // Variables
    $red:     red;
    $icon-base-size: 20px;

    // Structure
    .error-icon {
        display: inline-block;
        width: 8em;
        height: 8em;
        font-size: $icon-base-size;
        border-radius: 50%;
        border: 4px solid lighten($red, 20%);
        background-color: #fff;
        position: relative;
        overflow: hidden;
        transform-origin: center;
        animation: showError 180ms ease-in-out;
        transform: scale(1);
    }

    // Elements
    .error-icon {
        
        &__right, &__left {
            display: block;
            position: absolute;
            height: 4px;
            background-color: lighten($red, 20%);
            border-radius: 10px;
            width: 0px;
            transform-origin: 0 100%;
            animation: errorInPlace 140ms linear;
            animation-fill-mode: forwards;
        }
        &__right {
            transform: rotate(135deg);
            top: 1.6em;
            left: 6em;
            animation-delay: 300ms + 140ms;
        }
        &__left {
            transform: rotate(45deg);
            top: 1.7em;
            left: 2em;
            animation-delay: 300ms + 140ms + 140ms;
        }

    }

    @keyframes showError {
        from {
            transform: scale(0);
        }
        to {
            transform: scale(1);
        }
    }

    @keyframes errorInPlace {
        0% {
            width: 0px;
        }
        100% {
            width: 6.1em;
        }
    }
</style>